import React from "react";

export default function Sports() {
  const sports = [
    "Soccer ⚽",
    "Swimming 🏊‍♀️",
    "Bowling 🎳", 
    "Bocce Ball ☄️",
    "Basketball 🏀",
    "Baseball ⚾",
    "Horseback Riding 🐎",
  ];

  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-yellow-700 text-center mb-4">
        Sports Millie Has Tried
      </h2>

      <p className="text-center text-gray-700 max-w-2xl mx-auto mb-10">
        Exploring, learning, and having fun through movement 💛
      </p>

      <div className="flex flex-wrap justify-center gap-4">
        {sports.map((sport, index) => (
          <span
            key={index}
            className="px-6 py-3 bg-yellow-100 text-yellow-700 font-semibold rounded-full shadow-sm hover:bg-yellow-200 hover:scale-105 transition"
          >
            {sport}
          </span>
        ))}
      </div>
    </section>
  );
}
